import { af_za } from './tooltips/af_za_tooltips.js';
import { ar_sa } from './tooltips/ar_sa_tooltips.js';
import { ast_es } from './tooltips/ast_es_tooltips.js';
import { az_az } from './tooltips/az_az_tooltips.js';
import { bar } from './tooltips/bar_tooltips.js';
import { ba_ru } from './tooltips/ba_ru_tooltips.js';
import { be_by } from './tooltips/be_by_tooltips.js';
import { bg_bg } from './tooltips/bg_bg_tooltips.js';
import { brb } from './tooltips/brb_tooltips.js';
import { br_fr } from './tooltips/br_fr_tooltips.js';
import { bs_ba } from './tooltips/bs_ba_tooltips.js';
import { ca_es } from './tooltips/ca_es_tooltips.js';
import { cs_cz } from './tooltips/cs_cz_tooltips.js';
import { cy_gb } from './tooltips/cy_gb_tooltips.js';
import { da_dk } from './tooltips/da_dk_tooltips.js';
import { de_at } from './tooltips/de_at_tooltips.js';
import { de_ch } from './tooltips/de_ch_tooltips.js';
import { de_de } from './tooltips/de_de_tooltips.js';
import { el_gr } from './tooltips/el_gr_tooltips.js';
import { enp } from './tooltips/enp_tooltips.js';
import { enws } from './tooltips/enws_tooltips.js';
import { en_au } from './tooltips/en_au_tooltips.js';
import { en_ca } from './tooltips/en_ca_tooltips.js';
import { en_gb } from './tooltips/en_gb_tooltips.js';
import { en_us } from './tooltips/en_us_tooltips.js';
import { en_nz } from './tooltips/en_nz_tooltips.js';
import { en_pt } from './tooltips/en_pt_tooltips.js';
import { en_ud } from './tooltips/en_ud_tooltips.js';
import { eo_uy } from './tooltips/eo_uy_tooltips.js';
import { esan } from './tooltips/esan_tooltips.js';
import { es_ar } from './tooltips/es_ar_tooltips.js';
import { es_cl } from './tooltips/es_cl_tooltips.js';
import { es_ec } from './tooltips/es_ec_tooltips.js';
import { es_es } from './tooltips/es_es_tooltips.js';
import { es_mx } from './tooltips/es_mx_tooltips.js';
import { es_uy } from './tooltips/es_uy_tooltips.js';
import { es_ve } from './tooltips/es_ve_tooltips.js';
import { et_ee } from './tooltips/et_ee_tooltips.js';
import { eu_es } from './tooltips/eu_es_tooltips.js';
import { fa_ir } from './tooltips/fa_ir_tooltips.js';
import { fil_ph } from './tooltips/fil_ph_tooltips.js';
import { fi_fi } from './tooltips/fi_fi_tooltips.js';
import { fo_fo } from './tooltips/fo_fo_tooltips.js';
import { fra_de } from './tooltips/fra_de_tooltips.js';
import { fr_ca } from './tooltips/fr_ca_tooltips.js';
import { fr_fr } from './tooltips/fr_fr_tooltips.js';
import { fy_nl } from './tooltips/fy_nl_tooltips.js';
import { ga_ie } from './tooltips/ga_ie_tooltips.js';
import { gd_gb } from './tooltips/gd_gb_tooltips.js';
import { gl_es } from './tooltips/gl_es_tooltips.js';
import { gv_im } from './tooltips/gv_im_tooltips.js';
import { haw_us } from './tooltips/haw_us_tooltips.js';
import { he_il } from './tooltips/he_il_tooltips.js';
import { hi_in } from './tooltips/hi_in_tooltips.js';
import { hr_hr } from './tooltips/hr_hr_tooltips.js';
import { hu_hu } from './tooltips/hu_hu_tooltips.js';
import { hy_am } from './tooltips/hy_am_tooltips.js';
import { id_id } from './tooltips/id_id_tooltips.js';
import { ig_ng } from './tooltips/ig_ng_tooltips.js';
import { io_en } from './tooltips/io_en_tooltips.js';
import { isv } from './tooltips/isv_tooltips.js';
import { is_is } from './tooltips/is_is_tooltips.js';
import { it_it } from './tooltips/it_it_tooltips.js';
import { ja_jp } from './tooltips/ja_jp_tooltips.js';
import { jbo_en } from './tooltips/jbo_en_tooltips.js';
import { ka_ge } from './tooltips/ka_ge_tooltips.js';
import { kk_kz } from './tooltips/kk_kz_tooltips.js';
import { kn_in } from './tooltips/kn_in_tooltips.js';
import { ko_kr } from './tooltips/ko_kr_tooltips.js';
import { ksh } from './tooltips/ksh_tooltips.js';
import { kw_gb } from './tooltips/kw_gb_tooltips.js';
import { la_la } from './tooltips/la_la_tooltips.js';
import { lb_lu } from './tooltips/lb_lu_tooltips.js';
import { li_li } from './tooltips/li_li_tooltips.js';
import { lmo } from './tooltips/lmo_tooltips.js';
import { lol_us } from './tooltips/lol_us_tooltips.js';
import { lt_lt } from './tooltips/lt_lt_tooltips.js';
import { lv_lv } from './tooltips/lv_lv_tooltips.js';
import { lzh } from './tooltips/lzh_tooltips.js';
import { mi_nz } from './tooltips/mi_nz_tooltips.js';
import { mk_mk } from './tooltips/mk_mk_tooltips.js';
import { mn_mn } from './tooltips/mn_mn_tooltips.js';
import { ms_my } from './tooltips/ms_my_tooltips.js';
import { mt_mt } from './tooltips/mt_mt_tooltips.js';
import { nds_de } from './tooltips/nds_de_tooltips.js';
import { nl_be } from './tooltips/nl_be_tooltips.js';
import { nl_nl } from './tooltips/nl_nl_tooltips.js';
import { nn_no } from './tooltips/nn_no_tooltips.js';
import { no_no } from './tooltips/no_no_tooltips.js';
import { oc_fr } from './tooltips/oc_fr_tooltips.js';
import { ovd } from './tooltips/ovd_tooltips.js';
import { pl_pl } from './tooltips/pl_pl_tooltips.js';
import { pt_br } from './tooltips/pt_br_tooltips.js';
import { pt_pt } from './tooltips/pt_pt_tooltips.js';
import { qya_aa } from './tooltips/qya_aa_tooltips.js';
import { ro_ro } from './tooltips/ro_ro_tooltips.js';
import { rpr } from './tooltips/rpr_tooltips.js';
import { ru_ru } from './tooltips/ru_ru_tooltips.js';
import { se_no } from './tooltips/se_no_tooltips.js';
import { sk_sk } from './tooltips/sk_sk_tooltips.js';
import { sl_si } from './tooltips/sl_si_tooltips.js';
import { so_so } from './tooltips/so_so_tooltips.js';
import { sq_al } from './tooltips/sq_al_tooltips.js';
import { sr_sp } from './tooltips/sr_sp_tooltips.js';
import { sv_se } from './tooltips/sv_se_tooltips.js';
import { swg } from './tooltips/swg_tooltips.js';
import { sxu } from './tooltips/sxu_tooltips.js';
import { szl } from './tooltips/szl_tooltips.js';
import { ta_in } from './tooltips/ta_in_tooltips.js';
import { th_th } from './tooltips/th_th_tooltips.js';
import { tlh_aa } from './tooltips/tlh_aa_tooltips.js';
import { tl_ph } from './tooltips/tl_ph_tooltips.js';
import { tr_tr } from './tooltips/tr_tr_tooltips.js';
import { tt_ru } from './tooltips/tt_ru_tooltips.js';
import { uk_ua } from './tooltips/uk_ua_tooltips.js';
import { val_es } from './tooltips/val_es_tooltips.js';
import { vec_it } from './tooltips/vec_it_tooltips.js';
import { vi_vn } from './tooltips/vi_vn_tooltips.js';
import { yi_de } from './tooltips/yi_de_tooltips.js';
import { yo_ng } from './tooltips/yo_ng_tooltips.js';
import { zh_cn } from './tooltips/zh_cn_tooltips.js';
import { zh_hk } from './tooltips/zh_hk_tooltips.js';
import { zh_tw } from './tooltips/zh_tw_tooltips.js';
import { tok } from './tooltips/tok_tooltips.js';
import { fur_it } from './tooltips/fur_it_tooltips.js';

var language_tooltips = {
  'af_za': af_za,
  'ar_sa': ar_sa,
  'ast_es': ast_es,
  'az_az': az_az,
  'bar': bar,
  'ba_ru': ba_ru,
  'be_by': be_by,
  'bg_bg': bg_bg,
  'brb': brb,
  'br_fr': br_fr,
  'bs_ba': bs_ba,
  'ca_es': ca_es,
  'cs_cz': cs_cz,
  'cy_gb': cy_gb,
  'da_dk': da_dk,
  'de_at': de_at,
  'de_ch': de_ch,
  'de_de': de_de,
  'el_gr': el_gr,
  'enp': enp,
  'enws': enws,
  'en_au': en_au,
  'en_ca': en_ca,
  'en_gb': en_gb,
  'en_us': en_us,
  'en_nz': en_nz,
  'en_pt': en_pt,
  'en_ud': en_ud,
  'eo_uy': eo_uy,
  'esan': esan,
  'es_ar': es_ar,
  'es_cl': es_cl,
  'es_ec': es_ec,
  'es_es': es_es,
  'es_mx': es_mx,
  'es_uy': es_uy,
  'es_ve': es_ve,
  'et_ee': et_ee,
  'eu_es': eu_es,
  'fa_ir': fa_ir,
  'fil_ph': fil_ph,
  'fi_fi': fi_fi,
  'fo_fo': fo_fo,
  'fra_de': fra_de,
  'fr_ca': fr_ca,
  'fr_fr': fr_fr,
  'fy_nl': fy_nl,
  'ga_ie': ga_ie,
  'gd_gb': gd_gb,
  'gl_es': gl_es,
  'gv_im': gv_im,
  'haw_us': haw_us,
  'he_il': he_il,
  'hi_in': hi_in,
  'hr_hr': hr_hr,
  'hu_hu': hu_hu,
  'hy_am': hy_am,
  'id_id': id_id,
  'ig_ng': ig_ng,
  'io_en': io_en,
  'isv': isv,
  'is_is': is_is,
  'it_it': it_it,
  'ja_jp': ja_jp,
  'jbo_en': jbo_en,
  'ka_ge': ka_ge,
  'kk_kz': kk_kz,
  'kn_in': kn_in,
  'ko_kr': ko_kr,
  'ksh': ksh,
  'kw_gb': kw_gb,
  'la_la': la_la,
  'lb_lu': lb_lu,
  'li_li': li_li,
  'lmo': lmo,
  'lol_us': lol_us,
  'lt_lt': lt_lt,
  'lv_lv': lv_lv,
  'lzh': lzh,
  'mi_nz': mi_nz,
  'mk_mk': mk_mk,
  'mn_mn': mn_mn,
  'ms_my': ms_my,
  'mt_mt': mt_mt,
  'nds_de': nds_de,
  'nl_be': nl_be,
  'nl_nl': nl_nl,
  'nn_no': nn_no,
  'no_no': no_no,
  'oc_fr': oc_fr,
  'ovd': ovd,
  'pl_pl': pl_pl,
  'pt_br': pt_br,
  'pt_pt': pt_pt,
  'qya_aa': qya_aa,
  'ro_ro': ro_ro,
  'rpr': rpr,
  'ru_ru': ru_ru,
  'se_no': se_no,
  'sk_sk': sk_sk,
  'sl_si': sl_si,
  'so_so': so_so,
  'sq_al': sq_al,
  'sr_sp': sr_sp,
  'sv_se': sv_se,
  'swg': swg,
  'sxu': sxu,
  'szl': szl,
  'ta_in': ta_in,
  'th_th': th_th,
  'tlh_aa': tlh_aa,
  'tl_ph': tl_ph,
  'tr_tr': tr_tr,
  'tt_ru': tt_ru,
  'uk_ua': uk_ua,
  'val_es': val_es,
  'vec_it': vec_it,
  'vi_vn': vi_vn,
  'yi_de': yi_de,
  'yo_ng': yo_ng,
  'zh_cn': zh_cn,
  'zh_hk': zh_hk,
  'zh_tw': zh_tw,
  'tok': tok,
  'fur_it': fur_it
}
export const LanguageTooltips = language_tooltips;